import { render, staticRenderFns } from "./Jtron.vue?vue&type=template&id=7589f31a&scoped=true&"
import script from "./Jtron.vue?vue&type=script&lang=js&"
export * from "./Jtron.vue?vue&type=script&lang=js&"
import style0 from "./Jtron.vue?vue&type=style&index=0&id=7589f31a&scoped=true&lang=css&"
import style1 from "./Jtron.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7589f31a",
  null
  
)

export default component.exports